import { Injectable } from '@angular/core';
import { stores, themes } from '../../../environments/environment';
import { appConfig } from '../../../environments/environment';
import { StorageService } from './storage.service';

@Injectable()
export class EnvironmentService {

  private currentStoreKey: string;
  constructor(
    private storageService: StorageService
  ) {
    this.currentStoreKey = 'current_store';
    console.log(stores);
  }

  // To set Current Store for Skin changes
  public setStore(currentStore?: string) {
    if ((!currentStore || currentStore === undefined || !stores || !Object.keys(stores) ||
    Object.keys(stores).indexOf(currentStore) === - 1)) {
      currentStore = this.getDefaultStore();
    }
    this.storageService.setLocalItem(this.currentStoreKey, currentStore);
    return currentStore;
  }

  // To retreive current Store configurations
  public getStore(key?: string) {
    let currentStore = this.storageService.getLocalItem(this.currentStoreKey);
    if (!currentStore) {
      currentStore = this.setStore();
    }
    if (key) {
      return stores[currentStore][key];
    }
    return currentStore;
  }

  public get(key: string) {
    return appConfig[key];
  }

  public getDefaultStore() {

    Object.keys(stores).forEach(
      (key) => {
        if (stores[key]['default']) {
          return key;
        }
      }
    );
    return  Object.keys(stores)[0];
  }

  public getTheme(key?: string) {
    if (!key) {
      return this.getStore('theme');
    }
    return themes[this.getStore('theme')][key];
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/services/environment.service.ts